document.addEventListener("DOMContentLoaded", () => {
  const isDesktop = () => window.matchMedia("(min-width: 1100px)").matches;

  const headerWrapper = document.querySelector(".as-header-wrapper");
  const drawer = document.querySelector(".as-mob-drawer");

  let closeTimeout;
  let activeSubmenuItem = null;
  let isInsideMega = false;

  function activateFirstSubmenuItem(detailsEl) {
    const staticBlock = detailsEl.querySelector(".submenu-products--static");
    if (staticBlock) {
      staticBlock.hidden = false;
      return;
    }

    const firstItem = detailsEl.querySelector(".as-header__submenu-item");
    if (!firstItem) return;

    const handle = firstItem.dataset.handle;

    firstItem.classList.add("is-active");
    activeSubmenuItem = firstItem;

    document
      .querySelectorAll(".submenu-products:not(.submenu-products--static)")
      .forEach((p) => (p.hidden = true));

    const target = detailsEl.querySelector(
      `.submenu-products[data-handle="${handle}"]`,
    );

    if (target) target.hidden = false;
  }

  document.querySelectorAll(".as-header__submenu").forEach((submenu) => {
    submenu.addEventListener("mouseenter", () => {
      isInsideMega = true;
      clearTimeout(closeTimeout);
    });

    submenu.addEventListener("mouseleave", () => {
      isInsideMega = false;

      closeTimeout = setTimeout(() => {
        if (!isInsideMega && activeSubmenuItem) {
          activeSubmenuItem.classList.remove("is-active");
          activeSubmenuItem = null;
        }
      }, 120);
    });
  });

  function closeAllMega(exceptEl) {
    document.querySelectorAll(".as-header__details").forEach((el) => {
      if (el !== exceptEl) el.setAttribute("data-expanded", "false");
    });
  }

  document.querySelectorAll(".as-header__details").forEach((details) => {
    details.addEventListener("mouseenter", () => {
      if (!isDesktop()) return;

      if (details.classList.contains("is-esc-closed")) return;

      clearTimeout(closeTimeout);
      closeAllMega(details);
      details.setAttribute("data-expanded", "true");
      headerWrapper?.classList.add("is-mega-open");

      if (!activeSubmenuItem) {
        activateFirstSubmenuItem(details);
      }
    });

    details.addEventListener("mouseleave", () => {
      if (!isDesktop()) return;

      details.classList.remove("is-esc-closed");

      closeTimeout = setTimeout(() => {
        details.setAttribute("data-expanded", "false");

        const summary = details.querySelector(".as-header__summary");
        summary?.setAttribute("aria-expanded", "false");

        const anyOpen = document.querySelector(
          '.as-header__details[data-expanded="true"]',
        );

        if (!anyOpen) {
          headerWrapper?.classList.remove("is-mega-open");
        }
      }, 120);
    });

    // ===== Keyboard accessibility (additive; preserves hover) =====
    const a11ySummary = details.querySelector(".as-header__summary");
    const a11ySetExpanded = (open) => {
      details.setAttribute("data-expanded", open ? "true" : "false");
      if (a11ySummary)
        a11ySummary.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) {
        headerWrapper?.classList.add("is-mega-open");
      } else {
        const stillOpen = document.querySelector(
          '.as-header__details[data-expanded="true"]',
        );
        if (!stillOpen) headerWrapper?.classList.remove("is-mega-open");
      }
    };
    details.addEventListener("focusin", () => {
      if (!isDesktop()) return;
      if (details.classList.contains("is-esc-closed")) return;

      clearTimeout(closeTimeout);
      closeAllMega(details);
      a11ySetExpanded(true);
      if (!activeSubmenuItem) activateFirstSubmenuItem(details);
    });
    details.addEventListener("focusout", (e) => {
      if (!isDesktop()) return;
      if (details.contains(e.relatedTarget)) return;
      a11ySetExpanded(false);
    });
    details.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();

        closeMegaMenu(details);
        return;
      }
      if (a11ySummary && document.activeElement === a11ySummary) {
        if (
          (e.key === "Enter" || e.key === " ") &&
          a11ySummary.tagName !== "A"
        ) {
          e.preventDefault();
          a11ySetExpanded(details.getAttribute("data-expanded") !== "true");
        } else if (e.key === "ArrowDown") {
          e.preventDefault();
          a11ySetExpanded(true);
          const firstLink = details.querySelector(
            ".as-header__submenu a[href], .as-header__submenu button",
          );
          if (firstLink) firstLink.focus();
        }
      }
    });
  });

  function activateSubmenuItem(item) {
    const handle = item.dataset.handle;
    if (!handle) return;

    if (activeSubmenuItem && activeSubmenuItem !== item) {
      activeSubmenuItem.classList.remove("is-active");
    }

    item.classList.add("is-active");
    activeSubmenuItem = item;

    document
      .querySelectorAll(".submenu-products:not(.submenu-products--static)")
      .forEach((p) => (p.hidden = true));

    const target = document.querySelector(
      `.submenu-products[data-handle="${handle}"]`,
    );

    if (target) target.hidden = false;
  }

  document.querySelectorAll(".as-header__submenu-item").forEach((item) => {
    item.addEventListener("mouseenter", () => {
      activateSubmenuItem(item);
    });

    item.addEventListener("focusin", () => {
      activateSubmenuItem(item);
    });

    item.addEventListener("keydown", (e) => {
      if (
        (e.key === "Enter" || e.key === " ") &&
        document.activeElement === item
      ) {
        e.preventDefault();
        activateSubmenuItem(item);
      }

      if (e.key === "ArrowRight") {
        e.preventDefault();

        activateSubmenuItem(item);

        const details = item.closest(".as-header__details");
        const handle = item.dataset.handle;
        const target = details?.querySelector(
          `.submenu-products[data-handle="${handle}"]`,
        );

        const firstProductLink = target?.querySelector("a[href], button");

        if (firstProductLink) {
          firstProductLink.focus();
        }
      }
    });
  });
  function getVisibleProductLinks(details, handle) {
    const target = details?.querySelector(
      `.submenu-products[data-handle="${handle}"]:not([hidden]), .submenu-products--static:not([hidden])`,
    );

    if (!target) return [];

    return [...target.querySelectorAll(".as-header-product-card[href]")];
  }

  document.querySelectorAll(".as-header__details").forEach((details) => {
    details.addEventListener("keydown", (e) => {
      if (e.key !== "Tab" || e.shiftKey) return;

      const activeItem = details.querySelector(
        ".as-header__submenu-item.is-active",
      );
      if (!activeItem) return;

      const productLinks = getVisibleProductLinks(
        details,
        activeItem.dataset.handle,
      );
      if (!productLinks.length) return;

      const lastProduct = productLinks[productLinks.length - 1];

      if (document.activeElement !== lastProduct) return;

      const items = [...details.querySelectorAll(".as-header__submenu-item")];
      const currentIndex = items.indexOf(activeItem);
      const nextItem = items[currentIndex + 1];

      if (!nextItem) return;

      const nextLink = nextItem.querySelector(".as-header__submenu-link");

      if (nextLink) {
        e.preventDefault();
        nextLink.focus();
      }
    });
  });
  function getFocusableTopMenuItems() {
    return [
      ...document.querySelectorAll(".as-header__summary, .as-header__link"),
    ].filter((el) => {
      return el.offsetParent !== null;
    });
  }

  function focusTopMenuItem(current, direction) {
    const items = getFocusableTopMenuItems();
    const index = items.indexOf(current);
    if (index === -1) return;

    const nextIndex =
      direction === "next"
        ? (index + 1) % items.length
        : (index - 1 + items.length) % items.length;

    const next = items[nextIndex];
    const currentDetails = current.closest(".as-header__details");
    const nextDetails = next.closest(".as-header__details");

    if (currentDetails) currentDetails.setAttribute("data-expanded", "false");

    next.focus();

    if (nextDetails) {
      closeAllMega(nextDetails);
      nextDetails.setAttribute("data-expanded", "true");
      next.setAttribute("aria-expanded", "true");
      headerWrapper?.classList.add("is-mega-open");
      activateFirstSubmenuItem(nextDetails);
    }
  }

  document
    .querySelectorAll(".as-header__summary, .as-header__link")
    .forEach((topItem) => {
      topItem.addEventListener("keydown", (e) => {
        if (!isDesktop()) return;

        if (e.key === "ArrowRight") {
          e.preventDefault();
          focusTopMenuItem(topItem, "next");
        }

        if (e.key === "ArrowLeft") {
          e.preventDefault();
          focusTopMenuItem(topItem, "prev");
        }

        if (e.key === "ArrowDown") {
          const details = topItem.closest(".as-header__details");
          if (!details) return;

          e.preventDefault();
          closeAllMega(details);
          details.setAttribute("data-expanded", "true");
          topItem.setAttribute("aria-expanded", "true");
          headerWrapper?.classList.add("is-mega-open");
          activateFirstSubmenuItem(details);

          const firstSubmenuLink = details.querySelector(
            ".as-header__submenu-link",
          );
          firstSubmenuLink?.focus();
        }

        if (e.key === "Escape") {
          const details = topItem.closest(".as-header__details");
          if (!details) return;

          e.preventDefault();
          details.setAttribute("data-expanded", "false");
          topItem.setAttribute("aria-expanded", "false");
          headerWrapper?.classList.remove("is-mega-open");
          topItem.focus();
        }
      });
    });

  document.querySelectorAll(".as-header__submenu-link").forEach((link) => {
    link.addEventListener("keydown", (e) => {
      if (!isDesktop()) return;

      const currentItem = link.closest(".as-header__submenu-item");
      const details = link.closest(".as-header__details");
      if (!currentItem || !details) return;

      const items = [...details.querySelectorAll(".as-header__submenu-item")];
      const currentIndex = items.indexOf(currentItem);

      if (e.key === "ArrowDown") {
        e.preventDefault();
        const nextItem = items[currentIndex + 1] || items[0];
        const nextLink = nextItem.querySelector(".as-header__submenu-link");
        activateSubmenuItem(nextItem);
        nextLink?.focus();
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        const prevItem = items[currentIndex - 1] || items[items.length - 1];
        const prevLink = prevItem.querySelector(".as-header__submenu-link");
        activateSubmenuItem(prevItem);
        prevLink?.focus();
      }

      if (e.key === "ArrowRight") {
        e.preventDefault();

        activateSubmenuItem(currentItem);

        const handle = currentItem.dataset.handle;
        const target = details.querySelector(
          `.submenu-products[data-handle="${handle}"]`,
        );
        const firstProduct = target?.querySelector(
          ".as-header-product-card[href]",
        );

        firstProduct?.focus();
      }

      if (e.key === "ArrowLeft") {
        e.preventDefault();
        details.querySelector(".as-header__summary")?.focus();
      }

      if (e.key === "Escape") {
        e.preventDefault();
        closeMegaMenu(details);
      }
    });
  });

  document
    .querySelectorAll(".as-header-product-card[href]")
    .forEach((productLink) => {
      productLink.addEventListener("keydown", (e) => {
        if (!isDesktop()) return;

        const details = productLink.closest(".as-header__details");
        if (!details) return;

        const activeItem = details.querySelector(
          ".as-header__submenu-item.is-active",
        );
        const activeLink = activeItem?.querySelector(
          ".as-header__submenu-link",
        );

        if (e.key === "ArrowLeft") {
          e.preventDefault();
          activeLink?.focus();
        }

        if (e.key === "Escape") {
          e.preventDefault();
          closeMegaMenu(details);
        }
      });
    });
  function getVisibleFocusableElements(container) {
    return [
      ...container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
    ].filter((el) => {
      return (
        el.offsetParent !== null &&
        !el.hidden &&
        el.getAttribute("aria-hidden") !== "true"
      );
    });
  }

  function closeMegaMenu(details, returnFocus = true) {
    if (!details) return;

    clearTimeout(closeTimeout);

    const summary = details.querySelector(".as-header__summary");

    details.setAttribute("data-expanded", "false");
    details.classList.add("is-esc-closed");

    summary?.setAttribute("aria-expanded", "false");

    if (activeSubmenuItem) {
      activeSubmenuItem.classList.remove("is-active");
      activeSubmenuItem = null;
    }

    const stillOpen = document.querySelector(
      '.as-header__details[data-expanded="true"]',
    );

    if (!stillOpen) {
      headerWrapper?.classList.remove("is-mega-open");
    }

    if (returnFocus) {
      summary?.focus();
    }
  }

  function focusNextTopLevelAfterDetails(details) {
    const currentTopItem = details.querySelector(".as-header__summary");
    if (!currentTopItem) return false;

    const topItems = getFocusableTopMenuItems();
    const currentIndex = topItems.indexOf(currentTopItem);

    if (currentIndex === -1) return false;

    const nextTopItem = topItems[currentIndex + 1];

    closeMegaMenu(details, false);

    if (nextTopItem) {
      nextTopItem.focus();

      const nextDetails = nextTopItem.closest(".as-header__details");

      if (nextDetails) {
        closeAllMega(nextDetails);
        nextDetails.setAttribute("data-expanded", "true");
        nextTopItem.setAttribute("aria-expanded", "true");
        headerWrapper?.classList.add("is-mega-open");
        activateFirstSubmenuItem(nextDetails);
      }

      return true;
    }

    return false;
  }

  document.querySelectorAll(".as-header__details").forEach((details) => {
    details.addEventListener("keydown", (e) => {
      if (!isDesktop()) return;
      if (e.key !== "Tab" || e.shiftKey) return;

      const submenu = details.querySelector(".as-header__submenu");
      if (!submenu) return;

      const focusableInside = getVisibleFocusableElements(submenu);
      if (!focusableInside.length) return;

      const lastInside = focusableInside[focusableInside.length - 1];

      if (document.activeElement !== lastInside) return;

      if (focusNextTopLevelAfterDetails(details)) {
        e.preventDefault();
      }
    });
  });

  let setActiveTab = () => {};

  document.querySelectorAll(".as-mob-header__burger").forEach((burger) => {
    burger.addEventListener("click", () => {
      const isOpen = headerWrapper.classList.contains(
        "as-header-wrapper--open",
      );

      if (isOpen) {
        closeMobileDrawer();
      } else {
        openMobileDrawer(burger);
      }
    });
  });

  if (drawer) {
    const backBtn = drawer.querySelector(".as-mob-back");
    const titleEl = drawer.querySelector(".as-mob-head-title");
    const headEl = drawer.querySelector(".as-mob-head");
    let lastFocusedBeforeDrawer = null;

    function getDrawerFocusableElements() {
      return [
        ...drawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
        ),
      ].filter((el) => {
        return !el.hidden && el.offsetParent !== null;
      });
    }

    function trapDrawerFocus(event) {
      if (!headerWrapper.classList.contains("as-header-wrapper--open")) return;
      if (document.body.classList.contains("as-search-open")) return;
      if (event.key !== "Tab") return;

      const focusable = getDrawerFocusableElements();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }

      if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function setBurgerExpanded(open) {
      document.querySelectorAll(".as-mob-header__burger").forEach((b) => {
        b.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }

    function openMobileDrawer(trigger) {
      lastFocusedBeforeDrawer = trigger || document.activeElement;

      drawer.hidden = false;
      // Force reflow so the browser registers translateX(100%) before the
      // open class triggers the transition to translateX(0).
      drawer.offsetHeight; // eslint-disable-line no-unused-expressions
      drawer.removeAttribute("inert");
      drawer.setAttribute("aria-hidden", "false");
      setBurgerExpanded(true);

      headerWrapper.classList.add("as-header-wrapper--open");
      document.body.classList.add("as-fixed");

      setActiveTab("shop", true);

      setTimeout(() => {
        const firstFocusable = getDrawerFocusableElements()[0];
        firstFocusable?.focus();
      }, 50);

      document.addEventListener("keydown", trapDrawerFocus);
    }

    function closeMobileDrawer() {
      headerWrapper.classList.remove("as-header-wrapper--open");
      document.body.classList.remove("as-fixed");

      drawer.setAttribute("aria-hidden", "true");
      drawer.setAttribute("inert", "");
      setBurgerExpanded(false);

      document.removeEventListener("keydown", trapDrawerFocus);

      // Add hidden after the slide-out animation (350 ms) to preserve the transition.
      // The timeout is a fallback for reduced-motion / no-transition cases.
      let hiddenApplied = false;
      const applyHidden = () => {
        if (hiddenApplied) return;
        hiddenApplied = true;
        drawer.hidden = true;
        drawer.removeEventListener("transitionend", applyHidden);
      };
      drawer.addEventListener("transitionend", applyHidden);
      setTimeout(applyHidden, 400);

      if (lastFocusedBeforeDrawer) {
        lastFocusedBeforeDrawer.focus();
      }
    }

    document.addEventListener("keydown", (event) => {
      if (!headerWrapper.classList.contains("as-header-wrapper--open")) return;

      if (event.key === "Escape") {
        event.preventDefault();
        closeMobileDrawer();
      }
    });

    const stack = [{ level: 1, menuId: null, title: "" }];
    function render() {
      const state = stack[stack.length - 1];

      drawer.setAttribute("data-current-menu-level", state.level);
      drawer.setAttribute("data-current-menu-title", state.title || "");

      const isRoot = state.level === 1;
      headEl.style.display = isRoot ? "none" : "flex";
      backBtn.hidden = stack.length <= 1;

      if (state.level === 2) {
        titleEl.innerHTML = `
      <span class="as-mob-head-title-main">
        ${(state.title || "").toUpperCase()}
      </span>
    `;
      } else if (state.level === 3) {
        const parent = stack[stack.length - 2];
        const parentTitle = (parent?.title || "").toUpperCase();
        const currentTitle = (state.title || "").toUpperCase();

        titleEl.innerHTML = `
      <span class="as-mob-head-title-main">${parentTitle}</span>
      <span class="as-mob-head-title-sep"> / </span>
      <span class="as-mob-head-title-sub">${currentTitle}</span>
    `;
      } else {
        titleEl.textContent = "Menu";
      }

      drawer
        .querySelectorAll(".as-mob-panel")
        .forEach((p) => (p.hidden = true));

      if (state.menuId) {
        const panel = drawer.querySelector(
          `.as-mob-panel[data-menu-id="${state.menuId}"]`,
        );
        if (panel) panel.hidden = false;
      }
    }

    function resetLevels() {
      stack.length = 1;
      render();
    }

    setActiveTab = (tab, reset = false) => {
      drawer.setAttribute("data-active-tab", tab);

      drawer.querySelectorAll(".as-mob-tab").forEach((b) => {
        b.classList.toggle("is-active", b.dataset.tab === tab);
      });

      drawer.querySelectorAll(".as-mob-tab-panel").forEach((p) => {
        p.classList.toggle("is-active", p.dataset.panel === tab);
      });

      const showLevels = tab === "shop";
      drawer.querySelectorAll(".as-mob-level").forEach((l) => {
        l.style.display = showLevels ? "" : "none";
      });

      if (reset || !showLevels) resetLevels();
      else render();
    };

    drawer.addEventListener("click", (e) => {
      const tabBtn = e.target.closest(".as-mob-tab");
      if (tabBtn) {
        setActiveTab(tabBtn.dataset.tab);
        return;
      }

      if (drawer.getAttribute("data-active-tab") !== "shop") return;

      const btn = e.target.closest("[data-next-level]");
      if (!btn) return;
      const currentList = btn.closest(".as-mob-list");

      if (currentList) {
        currentList.querySelectorAll("li").forEach((li) => {
          li.classList.remove("is-active-default");
        });

        btn.closest("li")?.classList.add("is-active-default");
      }
      stack.push({
        level: Number(btn.dataset.nextLevel),
        menuId: btn.dataset.menuId,
        title: btn.dataset.title || "",
      });

      render();
      requestAnimationFrame(() => {
        const panel = drawer.querySelector(
          `.as-mob-panel[data-menu-id="${btn.dataset.menuId}"]`,
        );

        if (!panel) return;

        const firstFocusable = [
          ...panel.querySelectorAll(
            'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])',
          ),
        ].find((el) => !el.hidden && el.offsetParent !== null);

        firstFocusable?.focus();
      });
    });

    backBtn.addEventListener("click", () => {
      if (stack.length > 1) stack.pop();
      render();
    });

    setActiveTab("shop", true);
  }

  let lastScrollTop = 0;
  let headerHeight = headerWrapper?.offsetHeight || 0;

  window.addEventListener("resize", () => {
    headerHeight = headerWrapper?.offsetHeight || 0;
  });

  window.addEventListener("scroll", () => {
    if (!headerWrapper) return;
    if (headerWrapper.classList.contains("is-mega-open")) {
      headerWrapper.style.top = "0";
      return;
    }
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop < 100) {
      headerWrapper.style.top = "0";
      headerWrapper.classList.add("static");
      lastScrollTop = scrollTop;
      return;
    }
    headerWrapper.classList.remove("static");
    headerWrapper.style.top =
      scrollTop > lastScrollTop ? `-${headerHeight}px` : "0";
    lastScrollTop = scrollTop;
  });

function syncHeaderOffset() {
  if (!headerWrapper) return;

  const h = Math.round(headerWrapper.getBoundingClientRect().height);

  document.documentElement.style.setProperty(
    "--header-height",
    `${h}px`,
  );
}

  syncHeaderOffset();
  window.addEventListener("load", syncHeaderOffset);
  window.addEventListener("resize", syncHeaderOffset);
});

function initMobileBannerSlider(scope = document) {
  const slider = scope.querySelector("[data-banner-slider]");
  if (!slider) return;

  const track = slider.querySelector("[data-banner-track]");
  const dotsWrap = slider.querySelector("[data-banner-dots]");
  if (!track || !dotsWrap) return;

  const slides = [...track.querySelectorAll(".as-mob-banner--small")];
  if (slides.length <= 1) return;

  dotsWrap.innerHTML = slides.map(() => "<span></span>").join("");
  const dots = [...dotsWrap.children];

  const setActive = (i) => {
    dots.forEach((d) => d.classList.remove("is-active"));
    dots[i]?.classList.add("is-active");
  };

  setActive(0);

  let raf = null;
  track.addEventListener("scroll", () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      let best = 0;
      let dist = Infinity;
      slides.forEach((s, i) => {
        const d = Math.abs(s.offsetLeft - track.scrollLeft);
        if (d < dist) {
          dist = d;
          best = i;
        }
      });
      setActive(best);
    });
  });

  dots.forEach((dot, i) => {
    dot.addEventListener("click", () => {
      track.scrollTo({ left: slides[i].offsetLeft, behavior: "smooth" });
    });
  });
}

document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".as-header-product-card__add");
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = btn.dataset.variantId;

  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: +variantId,
            quantity: 1,
          },
        ],
      }),
    });

    const cart = await fetch("/cart.js").then((r) => r.json());

    const count = cart.item_count;

    document.querySelectorAll(".m-cart-count-bubble").forEach((bubble) => {
      if (count > 0) {
        bubble.textContent = count;
        bubble.classList.remove("m:hidden");
      } else {
        bubble.textContent = "0";
        bubble.classList.add("m:hidden");
      }
    });

    document.querySelectorAll(".m-cart-icon-bubble").forEach((link) => {
      link.setAttribute(
        "aria-label",
        `Cart with ${count} ${count === 1 ? "item" : "items"}`,
      );
    });

    if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
      window.MinimogEvents.emit(
        window.MinimogTheme.pubSubEvents.cartUpdate,
        cart,
      );
    }
  } catch (err) {
    console.error("Add to cart error:", err);
  }
});

document.addEventListener(
  "click",
  (event) => {
    const toggle = event.target.closest(".as-mobile-search-toggle");
    const header = document.querySelector(".as-header-wrapper");
    const closeSearch = document.querySelector("[data-close-search]");

    if (!toggle || !header) return;

    if (header.classList.contains("is-search-open")) {
      event.preventDefault();
      event.stopPropagation();

      if (closeSearch) closeSearch.click();
      header.classList.remove("is-search-open");
      document.body.classList.remove("as-search-open");
      return;
    }

    setTimeout(() => {
      header.classList.add("is-search-open");
      document.body.classList.add("as-search-open");
    }, 50);
  },
  true,
);

document.addEventListener("click", (event) => {
  if (event.target.closest("[data-close-search]")) {
    document
      .querySelector(".as-header-wrapper")
      ?.classList.remove("is-search-open");
    document.body.classList.remove("as-search-open");
  }
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;

  const header = document.querySelector(".as-header-wrapper");
  const closeSearch = document.querySelector("[data-close-search]");

  if (document.body.classList.contains("as-search-open")) {
    event.preventDefault();

    closeSearch?.click();
    header?.classList.remove("is-search-open");
    document.body.classList.remove("as-search-open");

    document.querySelector(".as-mobile-search-toggle")?.focus();
  }
});
